import styled from 'styled-components';

const AddressMapFieldStyle = styled.div`
	--radiusMap: var(--sp2x);
	--sizeSpinner: var(--sp5x);
	--borderSpinner: var(--sp1x);

	--sizeLocation: var(--sp5x);

	--chipInset: var(--sp2x);
	--chipPaddingY: var(--sp1-5x);
	--chipPaddingX: var(--sp1-5x);
	--chipRadius: var(--sp1-5x);
	--chipRowGap: var(--sp1-5x);
	--chipMaxWidthOffset: var(--sp10x);
	--chipNoteColor: var(--neutral1000);

	--warningSize: var(--sp2-5x);

	--locateButtonSize: var(--sp2-5x);
	--locateButtonPadding: var(--sp1-5x);
	--locateButtonInset: var(--sp2x);
	--toastBottom: var(--sp3x);
	--toastPaddingY: var(--sp1-5x);
	--toastPaddingX: var(--sp1-5x);
	--toastRadius: var(--sp1x);
	--pricingSpinnerSize: var(--sp2x);
	--pricingSpinnerBorder: 2px;

	position: relative;
	width: 100%;
	height: 100%;
	border-radius: var(--radiusMap);
	overflow: hidden;
	background: var(--neutral25);

	.murakami-gps-container {
		position: absolute;
		z-index: 10000000;
		transform: translate(-50%, -100%);
		cursor: grab;

		.murakami-location {
			font-size: var(--sizeLocation);
			color: var(--neutral1000);
		}
	}

	.map-container {
		width: 100%;
		height: 100%;

		/* Hide Yandex footer: "Open in Yandex Maps", terms, promo links */
		[class*='copyrights-promo'],
		[class*='gotoymaps'],
		[class*='map-copyrights-promo'],
		[class*='copyright__link'],
		[class*='copyright__wrap'] {
			display: none !important;
		}
	}

	.map-loading {
		position: absolute;
		inset: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		background: var(--neutral25);
		z-index: 20;
	}

	.map-spinner {
		width: var(--sizeSpinner);
		height: var(--sizeSpinner);
		border: var(--borderSpinner) solid var(--neutral300);
		border-top-color: var(--neutral1000);
		border-radius: 50%;
		animation: map-spin 0.75s linear infinite;
	}

	@keyframes map-spin {
		to {
			transform: rotate(360deg);
		}
	}

	.locate-button {
		position: absolute;
		right: var(--locateButtonInset);
		bottom: var(--locateButtonInset);
		top: auto;
		z-index: 10;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid var(--neutral300);
		border-radius: 100%;
		background: var(--mainColor);
		cursor: pointer;
		padding: var(--locateButtonPadding);
		transition:
			border-color var(--trTime) ease-out,
			background-color var(--trTime) ease-out;

		&:disabled {
			opacity: 0.5;
			cursor: default;
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover:not(:disabled) {
					border-color: var(--neutral1000);
				}
			}
		}
	}

	.locate-icon {
		font-size: var(--locateButtonSize);
		color: var(--neutral700);
	}

	.map-info-chip {
		position: absolute;
		top: var(--chipInset);
		left: var(--chipInset);
		z-index: 15;
		max-width: calc(100% - var(--chipMaxWidthOffset));
		padding: var(--chipPaddingY) var(--chipPaddingX);
		border-radius: var(--chipRadius);
		pointer-events: none;

		&.chip-delivery {
			background: var(--mainColor);
			border: 1px solid var(--neutral300);

			.chip-row1 {
				display: flex;
				align-items: center;
				gap: var(--chipRowGap);
			}

			.chip-label {
				color: var(--neutral1000);
			}

			.chip-note {
				display: block;
				margin-top: var(--sp0-5x);
				color: var(--chipNoteColor);
			}
		}

		&.chip-outside {
			background: var(--mainColor);
			border: 1px solid var(--neutral300);

			.chip-row1 {
				display: flex;
				align-items: center;
				gap: var(--chipRowGap);
			}

			.chip-icon {
				flex-shrink: 0;
			}

			.chip-icon-warning {
				flex-shrink: 0;
				color: var(--pink900);
				font-size: var(--warningSize);
			}
		}
	}

	.error-toast {
		position: absolute;
		bottom: var(--toastBottom);
		left: 50%;
		transform: translateX(-50%);
		background: var(--mainColor);
		border-radius: var(--toastRadius);
		padding: var(--toastPaddingY) var(--toastPaddingX);
		pointer-events: none;
		white-space: nowrap;
		z-index: 20;
		display: flex;
		align-items: center;
		gap: var(--chipRowGap);
		border: 1px solid var(--neutral300);
		opacity: 0.75;
		.error-icon {
			font-size: var(--warningSize);
			color: var(--error1000);
		}
	}

	.delivery-pricing-loading {
		width: var(--pricingSpinnerSize);
		height: var(--pricingSpinnerSize);
		border: var(--pricingSpinnerBorder) solid var(--neutral300);
		border-top-color: var(--neutral1000);
		border-radius: 50%;
		animation: map-spin 0.75s linear infinite;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--sizeLocation: var(--sp4x);
		--chipInset: var(--sp1-5x);
		--locateButtonInset: var(--sp1-5x);
		--toastBottom: var(--sp2-5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--chipInset: var(--sp1-5x);
		--locateButtonInset: var(--sp1-5x);
		--toastBottom: var(--sp2x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--chipInset: var(--sp1x);
		--locateButtonInset: var(--sp1x);
		--toastBottom: var(--sp2x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--chipInset: var(--sp1x);
		--chipMaxWidthOffset: var(--sp8x);
		--locateButtonInset: var(--sp1x);
		--locateButtonSize: var(--sp2x);
		--toastBottom: var(--sp1-5x);
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--chipInset: var(--sp0-5x);
		--chipPaddingY: var(--sp1x);
		--chipPaddingX: var(--sp1x);
		--chipMaxWidthOffset: var(--sp7x);
		--locateButtonInset: var(--sp0-5x);
		--locateButtonPadding: var(--sp1x);
		--locateButtonSize: var(--sp2x);
		--toastBottom: var(--sp1-5x);
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--chipInset: var(--sp0-5x);
		--chipPaddingY: var(--sp1x);
		--chipPaddingX: var(--sp1x);
		--chipMaxWidthOffset: var(--sp6x);
		--locateButtonInset: var(--sp0-5x);
		--locateButtonPadding: var(--sp1x);
		--locateButtonSize: var(--sp2x);
		--toastBottom: var(--sp1x);
		--sizeLocation: var(--sp4x);
	}
`;

export default AddressMapFieldStyle;
